import React from 'react';
import PropTypes from 'prop-types';

import {Box} from '@spothero/ui';

import SearchTermToggle from 'common/search-controls/search-term-toggle';
import SpotListBreadcrumbs from 'pages/search-transient-event-monthly/components/breadcrumbs';

const searchControlsInfoStyleProps = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 2.5,
    paddingX: 5,
    paddingBottom: 0,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'gray.medium',
};

const searchTermToggleStyleOverrides = {
    'div[role=tablist]': {
        borderBottom: '0',
    },
};

/* eslint-disable react/jsx-no-useless-fragment */
const SearchControlsInfo = ({isMobile, searchType, breadcrumbs}) => {
    const showBreadcrumbs =
        (!isMobile && searchType !== 'city') || searchType === 'event-package';
    const showSearchToggle =
        searchType !== 'event' && searchType !== 'event-package';
    const showNothing = searchType === 'event' && isMobile;

    return (
        <>
            {showNothing ? null : (
                <Box {...searchControlsInfoStyleProps}>
                    {showSearchToggle && (
                        <SearchTermToggle
                            styleOverrides={searchTermToggleStyleOverrides}
                        />
                    )}
                    {showBreadcrumbs && (
                        <SpotListBreadcrumbs
                            data={breadcrumbs}
                            {...(!showSearchToggle && {marginLeft: 0})}
                        />
                    )}
                </Box>
            )}
        </>
    );
};
/* eslint-enable react/jsx-no-useless-fragment */

SearchControlsInfo.propTypes = {
    isMobile: PropTypes.bool,
    searchType: PropTypes.string,
    breadcrumbs: PropTypes.object,
};

export default SearchControlsInfo;
